import { Component, Input, OnChanges } from "@angular/core";

@Component({
  selector: "app-difficulty",
  templateUrl: "./difficulty.component.html",
  styleUrls: ["./difficulty.component.scss"],
})
export class DifficultyComponent implements OnChanges {
  @Input() difficulty!: number;
  level = 0;

  ngOnChanges() {
    this.difficulty = +this.difficulty;
    this.handleLevel();
  }

  handleLevel() {
    const levelRaw = this.difficulty / 5;
    this.level = Math.trunc(levelRaw != 0 && levelRaw % 1 === 0 ? levelRaw - 1 : levelRaw);
    if (this.level > 2) {
      this.level = 2;
    }
  }
}
